/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'create-a-project',
  title: 'Create your first project',
  category: 'Getting started',
  summary:
    'Register, create a project, choose its status page address and add the first component PulseWatch should monitor.',
  keywords: ['project', 'setup', 'getting started', 'status page slug', 'component', 'check interval'],
};

export const loadComponent = () => import('./create-a-project.component').then((m) => m.CreateAProjectArticleComponent);
